import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Modal, Spin } from 'antd';
// components
import { ClientBox } from '../adminChangeGroup';
// actions
import clientAction from '../../../../redux/actions/client';
// types
import { stateType } from '../../../../types/types';
// styles
import './style.scss';
// icons
import { ReactComponent as CloseIcon } from 'assets/image/account/close4.svg';
import doneIcon from '../../../../assets/image/questions/after.svg';

const UnarchiveClient: React.FC<any> = () => {
  const [visible, setVisible] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const loader = useSelector((state: stateType) => state.clients.loaderModal, shallowEqual);
  const item: any = useSelector((state: stateType) => state.clients.item, shallowEqual);

  const open = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <button className="btn-form" onClick={open}>
        Unarchive Client
      </button>
      {visible && (
        <Modal
          closeIcon={<CloseIcon />}
          visible={visible}
          onOk={handleOk}
          closable={true}
          onCancel={handleCancel}
          centered
          maskTransitionName="none"
          footer={null}
          className="unarchive-client-modal"
        >
          {!confirm ? (
            <Spin spinning={loader}>
              <ModalContainer item={item} clientID={item.id} setConfirm={setConfirm} />
            </Spin>
          ) : (
            <Spin spinning={loader}>
              <ModalSuccess item={item} clientID={item.id} handleCancel={handleCancel} />
            </Spin>
          )}
        </Modal>
      )}
    </>
  );
};

export default UnarchiveClient;

const ModalContainer = ({ item, clientID, setConfirm }: any) => {
  const dispatch = useDispatch();

  const action = () => {
    dispatch(clientAction.unarchive(clientID, () => setConfirm(true)));
  };
  return (
    <div className="unarchive-client-container">
      <div className="unarchive-client-container__title">Are you sure you want to unarchive the following client?</div>
      <div className="unarchive-client-container__group-info">
        <ClientBox item={item} />
      </div>
      <div className="unarchive-client-container__block">
        <button className="btn-form" onClick={action}>
          Confirm
        </button>
      </div>
    </div>
  );
};

const ModalSuccess = ({ item, clientID, handleCancel }: any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clientAction.get(clientID));
    };
  }, []);

  return (
    <div className="unarchive-client-container">
      <img src={doneIcon} alt="" className="unarchive-client-success__success-img" />
      <div className="unarchive-client-container__title">You’ve successfully unarchived the following client.</div>
      <div className="unarchive-client-container__group-info unarchive-client-success__group-info">
        <ClientBox item={item} />
      </div>
      <div className="unarchive-client-container__block">
        <button className="btn-form" onClick={handleCancel}>
          Done
        </button>
      </div>
    </div>
  );
};
